import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowRight } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../ButtonLink';
import LazyImg from '../LazyImg';
import Rating from '../Rating';
import cssIndex from './ProductSpotlightSimple.module.scss';
import css from './ContentImageBlock.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ContentImageBlock = function ContentImageBlock(_ref) {
  var cta = _ref.cta,
      description = _ref.description,
      image = _ref.image,
      imageMobile = _ref.imageMobile,
      imageRight = _ref.imageRight,
      quoter = _ref.quoter,
      rating = _ref.rating,
      subHero = _ref.subHero,
      title = _ref.title;
  return /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.subHero, subHero)]),
    children: /*#__PURE__*/_jsxs("div", {
      className: cc([css.inner, _defineProperty({}, css.imageRight, imageRight)]),
      children: [/*#__PURE__*/_jsx(LazyImg, _objectSpread(_objectSpread({}, image), {}, {
        className: cc([css.lazyImg, cssIndex.isDesktop])
      })), /*#__PURE__*/_jsx(LazyImg, _objectSpread(_objectSpread({}, imageMobile), {}, {
        className: cc([css.lazyImg, cssIndex.isMobile])
      })), /*#__PURE__*/_jsxs("div", {
        className: cc([css.content, _defineProperty({}, css.darkFont, imageMobile.darkFont)]),
        children: [title && /*#__PURE__*/_jsx("h2", {
          className: css.title,
          children: title
        }), /*#__PURE__*/_jsxs("div", {
          className: css.description,
          children: [!!rating && /*#__PURE__*/_jsx("div", {
            className: css.rating,
            children: /*#__PURE__*/_jsx(Rating, {
              count: rating,
              size: 21
            })
          }), description, quoter && /*#__PURE__*/_jsx("span", {
            className: cc([css.quoter, css.title]),
            children: " \u2014 ".concat(quoter, " ")
          })]
        }), /*#__PURE__*/_jsxs(ButtonLink, _objectSpread(_objectSpread({}, cta), {}, {
          medium: true,
          children: [cta.text, /*#__PURE__*/_jsx("div", {
            className: cc([css.arrowRight, css.isMobile]),
            children: /*#__PURE__*/_jsx(ArrowRight, {})
          })]
        }))]
      })]
    })
  });
};

ContentImageBlock.defaultProps = {
  subHero: false,
  imageMobile: {
    alt: '',
    src: '',
    darkFont: false
  },
  imageRight: false,
  quoter: '',
  rating: null,
  title: ''
};
ContentImageBlock.propTypes = {
  cta: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  subHero: PropTypes.bool,
  description: PropTypes.string.isRequired,
  image: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  }).isRequired,
  imageMobile: PropTypes.shape({
    alt: PropTypes.string,
    darkFont: PropTypes.bool,
    src: PropTypes.string
  }),
  imageRight: PropTypes.bool,
  quoter: PropTypes.string,
  rating: PropTypes.number,
  title: PropTypes.string
};
export default ContentImageBlock;